import styled from '@emotion/styled'
import { Stack } from 'components/Stack'

export const SPlanFeaturesWrapper = styled(Stack)`
  align-items: center;
`

export const SFeaturesStack = styled(Stack)``
